// styles
import '../../scss/widgets/image-slider.scss';


;( function () {
    window.addEventListener("elementor/frontend/init", function () {
        elementorFrontend.hooks.addAction("frontend/element_ready/ikos-image-slider.default", function ($scope) {
            boom( $scope[0].querySelector('.ikos-image-slider > .swiper') )
        })
		
        elementorFrontend.hooks.addAction("frontend/element_ready/ikos-quote-slider.default", function ($scope) {
            boom( $scope[0].querySelector('.ikos-image-slider > .swiper') )
        })
    })
}) ()

function boom( node ) {

    if ( ! node || typeof node !== 'object' || node.nodeType === undefined ) {
        console.error( `Invalid slider element ${node}` );
    }


    if ( ! window.ikosSwiper ) {
        console.warn( 'window.ikosSwiper: dependency not found' );
    }

    const { Swiper, Navigation, Pagination } = window.ikosSwiper

    const options = {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 400,
        modules: [Navigation, Pagination],
        navigation: {
            nextEl: node.querySelector('.slider-button-next button'),
            prevEl: node.querySelector('.slider-button-prev button'),
        },
        pagination: {
            el: node.querySelector('.slider-pagination'),
            clickable: true
        },
    }

    new Swiper( node, options );

}
